import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.auth.ToggleLoginRegister', {
    registerText: 'Sign up',
    loginText: 'Log in',
});
